import { IAmazingOffer, IAmazingOfferResource } from "../../factories/amazingOffer/amazingOffer";

export class slide_show_controller {
    autoChange: ng.IPromise<any>;
    items = []



    selectedNav = 0
    constructor(private $interval: ng.IIntervalService, private $amazingOffer: IAmazingOfferResource) {
        "ngInject"
    }
    $onInit() {
        this.$amazingOffer.query(Response => {
            this.items = Response;
        })
        this.interval()

    }

    interval() {
        this.$interval.cancel(this.autoChange)
        this.autoChange = this.$interval(() => {
            if (this.selectedNav < this.items.length - 1) {

                this.selectedNav = this.selectedNav + 1
            }
            else {
                this.selectedNav = 0;
            }
        }, 4000)
    }
    onSwipeRight() {
        if (this.selectedNav > 0) {

            this.selectedNav = this.selectedNav - 1
        }
        else {
            this.selectedNav = this.items.length - 1;
        }
        this.interval()
    }
    onSwipeLeft() {
        if (this.selectedNav < this.items.length - 1) {

            this.selectedNav = this.selectedNav + 1
        }
        else {
            this.selectedNav = 0;
        }
        this.interval()
    }
    onClick($index) {
        this.selectedNav = $index;
        this.interval()
    }
}


// WEBPACK FOOTER //
// ./src/components/slide-show/slide-show.controller.ts